export const urls = {
    home: '/',
    createTenant: '/create-tenant',
    license: '/portal/license-overview',
    tenant: '/portal/tenant-settings',
    device: '/portal/device-settings',
    user: '/portal/user-settings',
    contactGroup: '/portal/contactgroup-settings',
    portalAccess: '/portal/portalaccess-settings',
    apiDocumentation: '/portal/api-documentation',
    postLogin: 'post-login-spa'
}